// import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import randomColor from 'randomcolor'
import { isNil } from 'lodash'

export default {
  components: {Datepicker},
  data () {
    return {}
  },
  computed: {},
  methods: {
    computedSalesData (_sales, entityPk = null) {
      let sales = _sales ? _sales.slice() : []
      let output = {
        entityPk,
        sales: [],
        salesCount: 0,
        actes: [],
        actesCount: 0,
        reservations: [],
        reservationsCount: 0,
        cancels: [],
        cancelCount: 0,
        totalBrut: 0,
        CA: 0,
        COM: 0,
        avgCA: 0,
        avgCOM: 0,
        avgRemuneration: 0
      }

      sales.forEach(sale => {
        if (sale.status === 'reserved') output.reservations.push(sale)
        if (sale.status === 'sold') output.actes.push(sale)
        if (sale.status === 'reserved' || sale.status === 'sold') {
          output.sales.push(sale)
        } else {
          output.cancels.push(sale)
        }
      })
      output.salesCount = output.sales.length
      output.actesCount = output.actes.length
      output.cancelCount = output.cancels.length
      output.reservationsCount = output.reservations.length
      output.totalBrut = output.sales.length + output.cancels.length

      output.CA = output.sales.reduce((accum, val) => {
        return accum + val.sale_price
      }, 0)

      output.sales.forEach(sale => {
        if (sale.sale_price && sale.seller_share) {
          let saleCom = sale.sale_price * (sale.seller_share / 100)
          output.COM = output.COM + saleCom
          output.avgRemuneration = output.avgRemuneration + sale.seller_share
        }
      })

      if (output.CA > 0 && output.totalBrut > 0) {
        output.avgCA = output.CA / (output.totalBrut - output.cancelCount)
        output.avgCOM = output.COM / (output.totalBrut - output.cancelCount)
        output.avgRemuneration = output.avgRemuneration / output.salesCount
      }
      return output
    },
    computedRdvsData (rdvs, entityPk = null) {
      let output = {
        entityPk,
        rdvs: [],
        total: {
          rdvs: [],
          R0: 0,
          R1: 0,
          R2: 0,
          R3: 0,
          count: 0
        },
        done: {
          rdvs: [],
          R0: 0,
          R1: 0,
          R2: 0,
          R3: 0,
          count: 0
        },
        cancel: {
          rdvs: [],
          R0: 0,
          R1: 0,
          R2: 0,
          R3: 0,
          count: 0
        }
      }
      rdvs.forEach(rdv => {
        if (!rdv) return
        if (rdv.canceled) {
          output.cancel.rdvs.push(rdv)
        } else if (rdv.successful) {
          output.done.rdvs.push(rdv)
        }
        output.total.rdvs.push(rdv)
      })

      output.total.count = output.total.rdvs.length
      output.done.count = output.done.rdvs.length
      output.cancel.count = output.cancel.rdvs.length

      let dests = [output.total, output.done, output.cancel]
      dests.forEach(dest => {
        dest.rdvs.forEach(rdv => {
          dest[rdv.rdv_type] += 1
        })
      })

      dests.forEach(dest => {
        if (dest.R0 > 0 && dest.R1 > 0) {
          dest.R0R1 = (dest.R1 / dest.R0 * 100).toFixed(0)
        }
        if (dest.R1 > 0 && dest.R2 > 0) {
          dest.R1R2 = (dest.R2 / dest.R1 * 100).toFixed(0)
        }
        if (dest.R2 > 0 && dest.R3 > 0) {
          dest.R2R3 = (dest.R3 / dest.R2 * 100).toFixed(0)
        }
      })
      delete output['rdvs']
      delete output.done['rdvs']
      delete output.total['rdvs']
      delete output.cancel['rdvs']
      return output
    },
    openStartMonthPicker () {
      this.$refs.startDatePicker.showCalendar()
    },
    openEndMonthPicker () {
      this.$refs.endDatePicker.showCalendar()
    },
    updateStartDate (d) {
      this.rawStartDate = d
      if (this.rawEndDate < d) {
        this.rawEndDate = this.startDate.endOf('month').toDate()
      }
      this.reloadEntitySellerStats()
    },
    updateEndDate (d) {
      this.rawEndDate = d
      this.reloadEntitySellerStats()
    },
    reloadEntitySellerStats () {
      console.warn('need to be override')
      // this.getEntitySellerStats()
    },
    createColor (seed) {
      return randomColor({
        seed
      })
    },
    getEntityRdvStats ({entityKey, entityPk, startDate, endDate, filters}) {
      startDate = startDate.clone()
      endDate = endDate.clone()

      let delta = endDate.diff(startDate, 'days')

      let previousStartDate = startDate.clone().subtract(delta, 'days')
      let previousEndDate = endDate.clone().subtract(delta, 'days')

      let params = {
        key: entityKey,
        pk: entityPk,
        start_date: startDate.format('DD/MM/YYYY'),
        end_date: endDate.format('DD/MM/YYYY'),
        previous_start_date: previousStartDate.format('DD/MM/YYYY'),
        previous_end_date: previousEndDate.format('DD/MM/YYYY')
      }
      if (isNil(filters) === false) {
        params = Object.assign(params, filters)
      }
      return this.$api.statisticService.getRdvData(params)
    },
    getEntitySalesStats ({entityKey, entityPk, startDate, endDate}) {
      startDate = startDate.clone()
      endDate = endDate.clone()

      let delta = endDate.diff(startDate, 'days')

      let previousStartDate = startDate.clone().subtract(delta, 'days')
      let previousEndDate = endDate.clone().subtract(delta, 'days')

      let params = {
        key: entityKey,
        pk: entityPk,
        start_date: startDate.format('DD/MM/YYYY'),
        end_date: endDate.format('DD/MM/YYYY'),
        previous_start_date: previousStartDate.format('DD/MM/YYYY'),
        previous_end_date: previousEndDate.format('DD/MM/YYYY')
      }
      return this.$api.statisticService.getSellerData(params)
    },
    addEntities (dest, key, entity, data) {
      if ((key in dest) === false) {
        dest[key] = {
          entity: Object.assign({}, entity),
          objectID: key,
          _color: this.createColor(key),
          sales: [],
          previous_sales: [],
          rdvs: [],
          previous_rdvs: []
        }
      }
      dest[key] = Object.assign(dest[key], data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/StatsMixin.js